var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.56 29.8621V10.5302H68.7636V29.8621H65.56ZM52.6353 29.8621V10.5302H55.8388V29.8621H52.6353ZM55.1484 21.4113V18.4839H66.858V21.4113H55.1484Z",
    fill: "#01221B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0455 30.1935C39.186 30.1935 37.5289 29.77 36.0744 28.9231C34.6384 28.0578 33.5061 26.8795 32.6776 25.3881C31.8675 23.8784 31.4624 22.1477 31.4624 20.1961C31.4624 18.2445 31.8675 16.5231 32.6776 15.0318C33.5061 13.522 34.6384 12.3437 36.0744 11.4968C37.5105 10.6314 39.1583 10.1988 41.0179 10.1988C42.2699 10.1988 43.4482 10.4289 44.5529 10.8892C45.6576 11.3311 46.6334 11.9479 47.4803 12.7395C48.3456 13.5312 49.0084 14.4518 49.4687 15.5012L46.5413 16.6888C46.2099 15.9891 45.7588 15.3724 45.1881 14.8384C44.6357 14.2861 44.0005 13.8626 43.2825 13.5681C42.5644 13.2735 41.8096 13.1262 41.0179 13.1262C39.8027 13.1262 38.7165 13.43 37.7591 14.0375C36.8201 14.6451 36.0744 15.4828 35.5221 16.5507C34.9882 17.6001 34.7212 18.8153 34.7212 20.1961C34.7212 21.577 34.9882 22.8013 35.5221 23.8692C36.0744 24.9371 36.8293 25.7748 37.7867 26.3824C38.7625 26.9899 39.8672 27.2937 41.1007 27.2937C41.9108 27.2937 42.6657 27.1372 43.3653 26.8242C44.0834 26.4928 44.7186 26.0417 45.2709 25.471C45.8417 24.9002 46.2927 24.2374 46.6242 23.4826L49.5516 24.6701C49.0913 25.7564 48.4377 26.723 47.5907 27.5699C46.7438 28.3984 45.7588 29.0428 44.6357 29.5031C43.5126 29.9634 42.3159 30.1935 41.0455 30.1935Z",
    fill: "#01221B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.147 29.8621L26.7141 10.5302H30.1386L22.323 29.8621H19.147ZM18.8156 29.8621L11 10.5302H14.3969L21.964 29.8621H18.8156Z",
    fill: "#01221B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7612 14.7147L76.7887 5L79.5879 5.00791L79.5674 12.2905L85.8605 8.65714L87.2602 11.0814L78.8607 15.9308L76.7612 14.7147Z",
    fill: "#FF521A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4092 18.7792L87.8242 13.9323L89.2214 16.358L82.9051 19.996L89.1974 23.644L87.7934 26.0657L79.4058 21.2029L79.4092 18.7792Z",
    fill: "#FFAE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7827 25.2853L76.8102 35L79.6094 34.9921L79.5888 27.7095L85.882 31.3429L87.2816 28.9186L78.8822 24.0692L76.7827 25.2853Z",
    fill: "#007A53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVchLogo);
export default __webpack_public_path__ + "static/media/vch_logo.85b76f9537e63c091cee64fd1192fb21.svg";
export { ForwardRef as ReactComponent };